import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  onRefresh = new Subject();
  constructor(private http: HttpClient) {}

  login(data) {
    return this.http
      .post(`${environment.apiUrl}/business/authenticate`, data)
      .pipe();
  }

  register(data) {
    return this.http
      .post(`${environment.apiUrl}/business/register`, data)
      .pipe();
  }

  forgotPassword(data) {
    return this.http
      .put(`${environment.apiUrl}/business/forgot-password`, data)
      .pipe();
  }

  changePassword(role, token, data) {
    if (role == 'rider') {
      return this.http
        .put(`${environment.apiUrl}/rider/change-password/${token}`, data)
        .pipe();
    } else {
      return this.http
        .put(`${environment.apiUrl}/business/change-password/${token}`, data)
        .pipe();
    }
  }

  verifyAccount(role, token) {
    if (role == 'rider') {
      return this.http
        .get(`${environment.apiUrl}/rider/verify/${token}`)
        .pipe();
    } else {
      return this.http
        .get(`${environment.apiUrl}/business/verify/${token}`)
        .pipe();
    }
  }

  saveSettings(data) {
    return this.http
      .put(`${environment.apiUrl}/business/save-settings`, data)
      .pipe();
  }

  refreshToken() {
    return this.http.get(`${environment.apiUrl}/business/refresh-token`).pipe();
  }

  getMineBusiness() {
    return this.http.get(`${environment.apiUrl}/business/mine`).pipe();
  }

  resetPassword(data) {
    return this.http
      .put(`${environment.apiUrl}/business/reset-password`, data)
      .pipe();
  }

  deleteAccount() {
    return this.http
      .delete(`${environment.apiUrl}/business/delete-account`)
      .pipe();
  }
}
